/* Aylesva Ecosystem — minimal vanilla JS: scroll reveal + stat count-up */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.ays-animate [data-ays-reveal]:not(.is-visible)');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach ? items.forEach(show) : Array.prototype.forEach.call(items, show);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    Array.prototype.forEach.call(items, function (el) { io.observe(el); });
  }

  function show(el) {
    el.classList.add('is-visible');
    var num = el.querySelector('[data-ays-count]');
    if (num && !num.dataset.aysCounted) countUp(num);
  }

  function countUp(el) {
    el.dataset.aysCounted = '1';
    var raw = el.getAttribute('data-ays-count');
    var target = parseFloat(raw.replace(/[^0-9.]/g, ''));
    if (!isFinite(target) || reduced) { return; }
    var prefix = raw.match(/^[^0-9]*/)[0];
    var suffix = raw.replace(/^[^0-9]*[0-9.,]+/, '');
    var start = null, dur = 1200;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = prefix + Math.round(target * eased).toLocaleString() + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  } else {
    initReveal();
  }
  /* Re-init when merchant edits sections in the Theme Editor */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
